"use client";

import { motion } from "framer-motion";
import Navbar from "@/app/components/Navbar";
import Footer from "@/app/components/Footer";

const COOKIES = [
  {
    category: "Essential Cookies",
    description: "Required for the website to function. These cannot be disabled.",
    examples: ["Session management", "Security features", "Load balancing"],
    duration: "Session",
  },
  {
    category: "Analytics Cookies",
    description: "Help us understand how visitors interact with our website.",
    examples: ["Page views", "Time on site", "Navigation patterns"],
    duration: "12 months",
  },
  {
    category: "Marketing Cookies",
    description: "Used to track visitors across websites for advertising purposes.",
    examples: ["Campaign tracking", "Targeted ads", "Conversion tracking"],
    duration: "6 months",
  },
];

export default function CookiesPage() {
  return (
    <>
      <Navbar />
      <main className="min-h-screen px-6 py-32" style={{ background: "#0A0908" }}>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl mx-auto"
        >
          <h1
            className="text-3xl md:text-4xl font-light mb-2"
            style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}
          >
            Cookie Policy
          </h1>
          <p
            className="text-xs mb-12"
            style={{ color: "rgba(245,240,232,0.3)", fontFamily: "'Montserrat', sans-serif" }}
          >
            Last updated: April 2024
          </p>

          <div className="space-y-8 text-sm leading-relaxed" style={{ color: "rgba(245,240,232,0.6)", fontFamily: "'Montserrat', sans-serif" }}>
            <section>
              <h2 className="text-lg font-light mb-3" style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}>
                What Are Cookies
              </h2>
              <p>
                Cookies are small text files stored on your device when you visit websites. They help remember your preferences and improve your browsing experience.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-light mb-4" style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}>
                Types of Cookies We Use
              </h2>
              <div className="space-y-4">
                {COOKIES.map((cookie) => (
                  <div key={cookie.category} className="p-4" style={{ border: "1px solid rgba(201,168,76,0.1)" }}>
                    <div className="flex items-center justify-between mb-2">
                      <h3 className="text-sm font-medium" style={{ color: "#F5F0E8", fontFamily: "'Montserrat', sans-serif" }}>
                        {cookie.category}
                      </h3>
                      <span
                        className="text-xs px-2 py-1"
                        style={{ background: "rgba(201,168,76,0.1)", color: "#C9A84C", fontFamily: "'Montserrat', sans-serif" }}
                      >
                        {cookie.duration}
                      </span>
                    </div>
                    <p className="mb-2">{cookie.description}</p>
                    <p className="text-xs" style={{ color: "rgba(245,240,232,0.35)" }}>
                      Examples: {cookie.examples.join(", ")}
                    </p>
                  </div>
                ))}
              </div>
            </section>

            <section>
              <h2 className="text-lg font-light mb-3" style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}>
                Managing Cookies
              </h2>
              <p className="mb-2">You can control or disable cookies through your browser settings:</p>
              <ul className="space-y-2 pl-4">
                <li>• Chrome: Settings → Privacy → Cookies</li>
                <li>• Firefox: Options → Privacy → Cookies</li>
                <li>• Safari: Preferences → Privacy → Cookies</li>
              </ul>
              <p className="mt-3">
                Note: Disabling essential cookies may affect website functionality.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-light mb-3" style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}>
                Updates to This Policy
              </h2>
              <p>
                We may update this Cookie Policy periodically. Any changes will be posted on this page with an updated date.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-light mb-3" style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}>
                Contact Us
              </h2>
              <p>
                Questions about our Cookie Policy? Contact us at support@aureliusco.com
              </p>
            </section>
          </div>
</motion.div>
      </main>
      <Footer />
    </>
  );
}